import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as innovationIdea from '../innovation-idea'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: innovationIdea.RESOURCE.payload.dimension.partialId,
      partialId: innovationIdea.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The Jira issue key that this idea is associated with',
    isOptional: true,
    name: 'Jira Issue Key',
    partialId: PartialId.Standard.create('jira_issue_key'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
